export const isAuthenticated = () =>
  localStorage.getItem("@token/mademil") !== null;
